// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../contexts/LedgerApiContext';
import { useParties } from '../../contexts/PartiesContext';
import { useScanProxyApiClient } from '../../contexts/ScanProxyApiContext';
import { appTransferContextWithDisclosures } from '../../utils/appTransferContextWithDisclosures';

const useTapCoin: () => UseMutationResult<
  void,
  string,
  {
    amount: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const scanProxyApi = useScanProxyApiClient();
  const { party: receiver } = useParties();

  return useMutation({
    mutationKey: ['tapCoin', ledgerApi],
    mutationFn: async ({ amount }) => {
      const { appTransferContext } = await appTransferContextWithDisclosures(scanProxyApi, 30);
      return ledgerApi.tapCoin(
        appTransferContext.amuletRules,
        receiver,
        amount,
        appTransferContext.openMiningRound,
      );
    },
    retry: false,
  });
};

export default useTapCoin;
